<template>
  <div v-parallax-fit="parallax" class="slide-magazin" id="slidemagazin-2">
    <img src="/themes/rise-theme/dist/images/estate/character-view/henry/06_SeniorDirectory@2x.png">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 8000,
          end: 9700,
          fromStyle: { transform: 'translateX(-50%) translateY(-300%)', opacity: 0 },
          toStyle: { transform: 'translateX(-50%) translateY(-300%)', opacity: 1 },
          easing: 'linear'
        },
        {
          start: 10000,
          end: 13000,
          fromStyle: { transform: 'translateX(-50%) translateY(-300%)' },
          toStyle: { transform: 'translateX(-50%) translateY(0%)' },
          easing: 'linear'
        },
        {
          start: 14000,
          end: 15000,
          fromStyle: { transform: 'translateX(-50%) translateY(0%)' },
          toStyle: { transform: 'translateX(-50%) translateY(0%)', opacity: 0 },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/4a.jpg',
          url: 'https://www.pewtrusts.org/en/research-and-analysis/blogs/stateline/2015/07/15/heirs-property-challenges-families-states',
          link_title: {
			'en': "Heirs' Property Challenges Families, States",
			'es': 'La propiedad de los herederos cuestiona a las familias, los estados'
		  },
        },
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/4b.png',
          url: 'https://www.ny1.com/nyc/all-boroughs/news/2019/03/19/going--going--gone--new-tactic-by-real-estate-investors-forcing-some-new-yorkers-from-their-homes-ny1-investigation',
          link_title: {
			'en': 'Going, Going, Gone: New Tactic by Real Estate Investors Forcing Some New Yorkers from Their Homes',
			'es': 'Going, Going, Gone: Nueva táctica de los inversores inmobiliarios que obligan a algunos neoyorquinos a abandonar sus hogares'
		  }
        }
      ],
      text: {
		'en': '"The problem with passing down property without a formal legal record is that any single owner can petition the court for a forced sale of the property. Over time...the risk of a money grab increase and family members become targets for real estate developers looking to score property below market value in popular locations."',
		'es': '"El problema de traspasar una propiedad sin un registro legal formal es que cualquier propietario individual puede solicitar al tribunal una venta forzosa de la propiedad. Con el tiempo... el riesgo de apropiación de dinero aumenta y los miembros de la familia se convierten en objetivos para los promotores inmobiliarios. buscando calificar propiedades por debajo del valor de mercado en ubicaciones populares".'
	  }
    };
    const text = {
		'en': 'This problem of passing down property within families without a formal legal record is not uncommon and originates from Jim Crow laws, when Black Americans did not have access to the legal system, according to legal experts.',
		'es': 'Este problema de transmitir propiedades dentro de familias sin un registro legal formal no es raro y se origina en las leyes de Jim Crow, cuando los afroamericanos no tenían acceso al sistema legal, según expertos legales.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateX(-50%) translateY(-150%)') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slidemagazin-2'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide-magazin {
  max-width: 600px;
  width: 100%;
  height: 651px;
  position: absolute;
  top: -8%;
  left: 50%;
  transform-origin: center;
  transition: all 0.7s linear;
}

@media screen and (max-width: 1440px) {
  .slide-magazin {
    max-width: 550px;
    height: 600px;
    top: -8%;
  }
}

@media screen and (max-width: 1280px) {
  .slide-magazin {
    max-width: 365px;
    height: 400px;
  }
}

@media screen and (max-width: 650px) {
  .slide-magazin {
    max-width: 190px;
    height: 210px;
	  //top: -150%;
  }
}
</style>
